import {xvk} from '../api/notes'

export function getUrlParams(key: string) {
    return new URLSearchParams(xvk)
        .get(key)
}